import React from 'react';

import { ChatPanel } from '~/components/AiChat/components/ChatPanel';

import { useEmbeddedChatContext } from '../EmbeddedChatContext';

import { HistoryView } from './HistoryView';

export const EmbeddedChatContent: React.FC = () => {
  const { isSearchActive } = useEmbeddedChatContext();

  if (isSearchActive) {
    return <HistoryView />;
  }

  return <ChatPanel showTitle={false} />;
};
